import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Signature } from '@/containers/Settings/Signature/Signature'

import { EditableZone } from './EditableZone'

export interface InvoicingPreviewWatermarkProps {
  signature: string | null | undefined
  onMutate: () => void
  children: React.ReactNode
}

export const InvoicingPreviewWatermark = ({
  signature,
  onMutate,
  children,
}: InvoicingPreviewWatermarkProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'settings' })
  const [open, setOpen] = useState(false)

  return (
    <>
      <EditableZone
        onClick={() => setOpen(true)}
        ariaLabel={t('invoicing.preview.watermark.title')}
        className="inline-block w-auto"
      >
        {children}
      </EditableZone>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t('invoicing.preview.watermark.title')}</DialogTitle>
          </DialogHeader>
          <Signature
            signature={signature ?? null}
            onUploadSuccess={() => {
              onMutate()
              setOpen(false)
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
